import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import GlassCard from "@/components/GlassCard";
import NeonButton from "@/components/NeonButton";

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-20 md:pt-8 pb-32 px-4 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full"
      >
        <GlassCard hover={false} className="text-center p-8">
          <XCircle className="mx-auto mb-4 text-gray-500" size={64} />
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-gray-400 mb-6">
            No worries! You can subscribe anytime when you're ready to unlock all features.
          </p>
          
          <div className="space-y-3">
            <NeonButton onClick={() => navigate("/pricing")} className="w-full">
              <ArrowLeft size={18} className="mr-2" />
              Back to Pricing
            </NeonButton>
            <NeonButton variant="ghost" onClick={() => navigate("/studio")} className="w-full">
              Continue with Free
            </NeonButton>
          </div>
        </GlassCard>
      </motion.div>
    </div>
  );
};

export default SubscriptionCancel;
